import axios from 'axios';
import { getDefaultStore } from 'jotai';
import { authUserMetaAtom } from '@/store/authAtoms';
import { getCsrfToken } from '@/lib/csrf';
import { env } from '@/lib/env';

export const api = axios.create({
  baseURL: env.apiUrl,
  withCredentials: true,
});

const store = getDefaultStore();

api.interceptors.request.use((config) => {
  const csrfToken = getCsrfToken();
  if (csrfToken) config.headers['X-XSRF-ADMIN-TOKEN'] = csrfToken;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err: unknown) => {
    if (axios.isAxiosError(err) && err.response?.status === 401) {
      store.set(authUserMetaAtom, null);
      if (globalThis.location.pathname !== '/login') {
        globalThis.location.href = '/login';
      }
    }

    return Promise.reject(err);
  },
);
